import { BasicOfferCard } from './basic-offer-card'
import { ComplexOfferCard } from './complex-offer-card'
import { OfferCard as HorizontalOfferCard } from 'app/features/offer/components'

export const OfferCardContent = ({ complexView, offer, showEndTime, withBackgroundImage, imagePriority }) => {
  const OfferCard = complexView ? ComplexOfferCard : BasicOfferCard
  if (withBackgroundImage) {
    return <HorizontalOfferCard {...offer} size="sm" imagePriority={imagePriority} />
  }
  return <OfferCard offer={offer} showEndTime={showEndTime} imagePriority={imagePriority} />
}
